// V1
import "./Notification.css";

function Notification({ count }) {
  return <div className="app-notification">{count > 99 ? "99+" : count}</div>;
}

export default Notification;
